/**
 *
 * A service to detect the current geolocation of the user devices
 * Right now only used by native mobile
 *
 * */

import { geolocationApi } from '@aqx-core/common/api/geolocation/api';

import { configViewController } from '../config';
import { MAX_RETRY_COUNT, RETRY_DELAY_MS } from './constants';
import { geolocationService } from './service';

class GeolocationViewController {
  private retryCount = 0;

  public getCurrentGeolocation = () => {
    return geolocationService.context.geolocation;
  };

  public getIsChina = () => {
    return geolocationService.context.isChina;
  };

  public init = () => {
    this.retrieveGeolocation();
  };

  private retrieveGeolocation = async () => {
    try {
      const { result } = await geolocationApi.getGeolocation();

      if (result) {
        geolocationService.setGeolocation(result);
        if (result.country === 'CN') {
          geolocationService.setIsChina(true);
          configViewController.switchToFallbackDomain(); // Use fallback domain (for Hantec , it should be webtrader.hmarkets.cn)
        } else {
          geolocationService.setIsChina(false);
        }
      }
      geolocationService.setIsLoadingGeolocation(false);
    } catch (error) {
      this.retryCount = this.retryCount + 1;
      if (this.retryCount < MAX_RETRY_COUNT) {
        setTimeout(() => {
          this.retrieveGeolocation();
        }, RETRY_DELAY_MS);
      } else {
        geolocationService.setIsLoadingGeolocation(false);
      }
    }
  };
}

const geolocationViewController = new GeolocationViewController();
export default geolocationViewController;
